import { useRouter, useSearchParams } from 'next/navigation';

export function useBackNavigation() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const from = searchParams.get('from');
  const handleBack = (fallbackPath?: string) => {
    if (from) {
      router.push(from);
    } else if (fallbackPath) {
      router.push(fallbackPath);
    } else {
      router.back();
    }
  };
  return { handleBack };
}
